<template>
    <v-container fluid class="pa-0 ma-0" style="position: fixed; height: 0 ; z-index: 10000" >
        <v-row align="center" justify="center" style="height: 0" >
            <v-col cols="6">

                <v-alert v-for="notification in notifications" :key="notification.message"
                         :type="notification.type"
                         :dismissible="true"
                         elevation="24"
                         class="mt-5"
                >
                    {{notification.message}}
                </v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {NOTIFICATION_NS} from "@/store/modules/notification/constants";
    import {mapGetters} from "vuex";

    export default {
        name: "NotificationsDisplay",
        computed: {
            ...mapGetters(NOTIFICATION_NS, [
                'notifications'
            ])
        }
    }
</script>